<a id="csv-donwload"></a>

<p-panel
  header="検索"
  [toggleable]="true"
  [collapsed]="false">
  <form
    [formGroup]="form"
    #f="ngForm">
    <div class="grid">
      <div class="col-6">
        <div>
          <b>JAN検索</b>
        </div>
        <div class="custom-iconfield">
          <i class="pi pi-search"></i>
          <textarea
            placeholder="JAN or ASIN検索"
            rows="4"
            id="keyword"
            formControlName="keyword"
            class="input-full"></textarea>
        </div>
      </div>
      <div class="col-6">
        <div>
          <b>その他設定</b>
        </div>
        <div class="field-checkbox">
          <p-checkbox
            formControlName="showOldProducts"
            [binary]="true"
            inputId="binary"></p-checkbox>
          <label for="binary">過去商品を表示する</label>
        </div>
      </div>
      <div class="col-2">
        <p-button
          styleClass="p-button-success"
          label="JAN or ASIN検索"
          icon="pi pi-search"
          (onClick)="doSearch()"></p-button>
      </div>
      <div class="col-2">
        <p-button
          styleClass="p-button"
          label="前月比5%増の商品のみ表示"
          icon="pi pi-search"
          (onClick)="doSearchFive()"></p-button>
      </div>
      <div class="col-2">
        <p-button
          styleClass="p-button"
          label="全て表示"
          icon="pi pi-search"
          (onClick)="doShowAll()"></p-button>
      </div>
    </div>
  </form>
</p-panel>
<div class="table-header-sticky-outer">
  全{{ irisProducts?.length?.toLocaleString() || 0 }}件
  <p-table
    #irisTable
    [value]="irisProducts"
    columnResizeMode="expand"
    [tableStyle]="{ 'min-width': '50rem' }"
    class="table-header-sticky"
    sortMode="multiple"
    [paginator]="true"
    [rows]="100"
    [globalFilterFields]="['productCode', 'productName', 'asin', 'jan', 'modelNumber']">
    <ng-template #caption>
      <div class="table-caption">
        <div class="grid">
          <div class="col-3">
            <div class="p-d-flex">
              <button
                type="button"
                pButton
                iconOnly
                pRipple
                (click)="downloadCsv(irisTable)"
                class="p-mr-2"
                pTooltip="CSV"
                tooltipPosition="bottom">
                <i
                  class="pi pi-download"
                  aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="col-3"></div>
          <div class="col-5">
            <input
              pInputText
              class="input-full"
              type="text"
              (input)="irisTable.filterGlobal(onFilterInput($event), 'contains')"
              placeholder="検索キーワード" />
          </div>
          <div class="col-1">
            <button
              pButton
              class="p-button-outlined"
              (click)="clear(irisTable)">
              <i
                class="pi pi-filter-slash"
                aria-hidden="true"></i>
              Clear
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th
          width="5%"
          pSortableColumn="productCode">
          商品コード
          <p-sorticon field="productCode"></p-sorticon>
        </th>
        <th width="15%">商品名</th>
        <th width="7%">JAN/ASIN</th>
        <th
          width="3%"
          pSortableColumn="modelNumber">
          型番
          <p-sorticon field="modelNumber"></p-sorticon>
        </th>
        <th
          width="5%"
          pSortableColumn="discontinuedSchedule">
          廃盤予定
          <p-sorticon field="discontinuedSchedule"></p-sorticon>
        </th>
        <th
          width="5%"
          pSortableColumn="note">
          備考
          <p-sorticon field="note"></p-sorticon>
        </th>
        <th
          width="5%"
          pSortableColumn="lvonPrice">
          LVON価格
          <p-sorticon field="lvonPrice"></p-sorticon>
        </th>
        <th
          width="5%"
          pSortableColumn="amazonPrice">
          販売価格
          <p-sorticon field="amazonPrice"></p-sorticon>
        </th>
        <th
          width="3%"
          pSortableColumn="profitPrice">
          利益額
          <p-sorticon field="profitPrice"></p-sorticon>
        </th>
        <th
          width="3%"
          pSortableColumn="profitRate">
          利益率
          <p-sorticon field="profitRate"></p-sorticon>
          <p-columnfilter
            field="profitRate"
            matchMode="between"
            display="menu"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false">
            <ng-template
              #filter
              let-filter="filterCallback">
              <p-slider
                [ngModel]="profitValues"
                [range]="true"
                (onSlideEnd)="filter($event.values)"
                [min]="0"
                [max]="1"
                [step]="0.01"></p-slider>
              <div class="flex align-items-center justify-content-center px-2">
                <span>{{ profitValues[0] }} -</span>
                <span>{{ profitValues[1] }}</span>
              </div>
            </ng-template>
          </p-columnfilter>
        </th>
        <th
          width="3%"
          pSortableColumn="orderLevel">
          発注レベル
          <p-sorticon field="orderLevel"></p-sorticon>
          <p-columnfilter
            field="orderLevel"
            matchMode="in"
            display="menu"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false">
            <ng-template
              #filter
              let-value
              let-filter="filterCallback">
              <p-selectbutton
                [options]="filterOrderLevels"
                [ngModel]="value"
                multiple="multiple"
                optionLabel="name"
                optionValue="value"
                (onChange)="filter($event.value)"></p-selectbutton>
            </ng-template>
          </p-columnfilter>
        </th>
        <th
          width="4%"
          pSortableColumn="useFba">
          FBA納品
          <p-sorticon field="useFba"></p-sorticon>
        </th>
        <th width="5%">メモ</th>
        <th
          width="3%"
          pSortableColumn="lastImportedAt">
          最終更新日
          <p-sorticon field="lastImportedAt"></p-sorticon>
        </th>
        <th
          width="3%"
          pSortableColumn="createdAt">
          登録日
          <p-sorticon field="createdAt"></p-sorticon>
        </th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-iris>
      @if (canShowRecord(iris)) {
        <tr class="{{ getRowStyle(iris.isOldProduct) }}">
          <td>
            {{ iris.productCode }}
            <br />
            @if (isOverSize160(iris)) {
              <p-badge
                [value]="1980"
                severity="danger"
                class="mr-2"></p-badge>
            }
            <br />
            @if (iris.isBigType) {
              <p-tag
                value="大型"
                severity="warning"
                class="mr-2"></p-tag>
            }
          </td>
          <td>
            {{ iris.productName }}
            <br />
            <app-keepa-graph [asin]="iris.firstAsin"></app-keepa-graph>
          </td>
          <td>
            {{ iris.jan }},
            <span [innerHtml]="iris.asinsHtml"></span>
          </td>
          <td>
            {{ iris.modelNumber }}
          </td>
          <td>
            {{ iris.discontinuedSchedule }}
          </td>
          <td>
            {{ iris.note }}
          </td>
          <td>
            {{ iris.lvonPriceInTax.toLocaleString() }}
            <br />
            ({{ iris.lvonPrice.toLocaleString() }})
            @if (getLvonDiffPrice(iris)) {
              <div [style]="getProfitStyle(getLvonDiffPrice(iris))">(前月比{{ getLvonDiffPrice(iris) }})</div>
            }
          </td>
          <td>
            {{ iris.amazonPrice.toLocaleString() }}
            <br />
            ({{ getViewFee(iris.fee) }})
          </td>
          <td>
            <span [style]="getProfitStyle(iris.profitPrice)">
              {{ iris.profitPrice.toLocaleString() }}
            </span>
          </td>
          <td>
            <span [style]="getProfitStyle(iris.profitPrice)">
              {{ iris.profitRate | percent: '1.1' }}
            </span>
          </td>
          <td>
            @if (iris.orderLevel && iris.orderLevel != '-') {
              <p-tag value="{{ getOrderLevel(iris.orderLevel) }}"></p-tag>
            }
            <br />
            <i
              class="pi pi-cog clickable"
              (click)="openOrderLevelSetting(opOrderLevel, $event, iris)"></i>
            @if (hasLastOrderLevel()) {
              <div>
                <button
                  pButton
                  type="button"
                  class="p-button-sm p-button-rounded"
                  (click)="updateOrderLevel(null, lastOrderLevel, iris)">
                  同
                </button>
              </div>
            }
          </td>
          <td>
            <p-toggleswitch
              (onChange)="setUseFba($event, iris)"
              [(ngModel)]="iris.useFba"></p-toggleswitch>
          </td>
          <td pEditableColumn>
            <p-celleditor>
              <ng-template #input>
                <textarea
                  pInputTextarea
                  [(ngModel)]="iris.memo"
                  (blur)="updateMemo(iris)"
                  (keydown.enter)="updateMemo(iris)"></textarea>
              </ng-template>
              <ng-template #output>
                {{ iris.memo }}
              </ng-template>
            </p-celleditor>
          </td>
          <td>{{ iris.lastImportedAt }}</td>
          <td>{{ iris.createdAt }}</td>
        </tr>
      }
    </ng-template>
  </p-table>
</div>

<p-popover #opOrderLevel>
  <ng-template #content>
    <p-selectbutton
      [options]="orderLevels"
      optionLabel="name"
      optionValue="value"
      (onChange)="updateOrderLevel(opOrderLevel, $event.value)"></p-selectbutton>
  </ng-template>
</p-popover>
